import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ArticleService {

  constructor(private http: HttpClient) { }

  get_pdf_links(id: string): Observable<any> {
    const url = environment.backend_url + 'beta/articles/pdfs/' + id + '?key=7xOyNH554tY83cBN7Ktpw3s1y68ql6Eg';
    return this.http.get(url).pipe(catchError(this.handleError));
  }

  get_your_list(p_id: string): Observable<any> {
    const url = environment.backend_url + 'beta/article_get_your_list/' + p_id + '?key=7xOyNH554tY83cBN7Ktpw3s1y68ql6Eg';
    return this.http.get(url).pipe(catchError(this.handleError));
  }

  //-----------------Images CRUD operation(need to remove as really not Used, security Risk!!!)-----------------//
  // get_image(slug) {
  //   const final_url = environment.backend_url + 'beta/image/' + slug + '?key=7xOyNH554tY83cBN7Ktpw3s1y68ql6Eg';
  //   return this.http.get(final_url).pipe(catchError(this.handleError));
  // }

  // get_all_images() {
  //   const table_url = environment.backend_url + 'beta/image?key=7xOyNH554tY83cBN7Ktpw3s1y68ql6Eg';
  //   return this.http.get(table_url).pipe(catchError(this.handleError));
  // }

  // deleteimage(slug) {
  //   const final_url = environment.backend_url + 'beta/image/' + slug + '?key=7xOyNH554tY83cBN7Ktpw3s1y68ql6Eg';
  //   return this.http.delete(final_url).pipe(catchError(this.handleError));
  // }

  //-----------------Doctor Info CRUD operation(need to remove as really not Used, security Risk!!!)-----------------//
  // get_doctor_details(slug) {
  //   const edit_url = environment.backend_url + 'beta/doctor-info/' + slug + '?key=7xOyNH554tY83cBN7Ktpw3s1y68ql6Eg';
  //   return this.http.get(edit_url).pipe(catchError(this.handleError));
  // }

  // get_all_doctor_info() {
  //   const table_url = environment.backend_url + 'beta/doctor-info?key=7xOyNH554tY83cBN7Ktpw3s1y68ql6Eg';
  //   return this.http.get(table_url).pipe(catchError(this.handleError));
  // }

  // add_doctorinfo(finalJson) {
  //   const data = JSON.stringify(finalJson);
  //   const final_url = environment.backend_url + 'beta/angular/doctor-info/?key=7xOyNH554tY83cBN7Ktpw3s1y68ql6Eg';
  //   return this.http.post(final_url, {'json': data});
  // }

  // update_dotor_details(model, slug) {
  //   const data = JSON.stringify(model);
  //   const final_url = environment.backend_url + 'beta/angular/doctor-info/' + slug + '?key=7xOyNH554tY83cBN7Ktpw3s1y68ql6Eg';
  //   return this.http.put(final_url, {'json': data}).pipe(catchError(this.handleError));
  // }

  // doctor_deleteform(slug) {
  //   const final_url = environment.backend_url + 'beta/doctor-info/' + slug + '?key=7xOyNH554tY83cBN7Ktpw3s1y68ql6Eg';
  //   return this.http.delete(final_url).pipe(catchError(this.handleError));
  // }

  registration(user: any): Observable<any> {
    const url = environment.backend_url + 'beta/subscriber/new_polling_user?key=7xOyNH554tY83cBN7Ktpw3s1y68ql6Eg';
    return this.http.post(url, { 'json': user }).pipe(catchError(this.handleError));
  }

  private handleError(error: any) {
    return throwError(error);
  }
}
